import { css, styled } from "@compiled/react";

import AkOfficeBuildingIcon from "@atlaskit/icon/core/office-building";
import { token as akToken } from "@atlaskit/tokens";
import type { IconColor } from "@atlaskit/tokens/css-type-schema";

import { Centered } from "../centered/centered";

const OrgAvatarBackground = styled(Centered)(
    css({
        width: `32px`,
        height: `32px`
    }),
    {
        borderRadius: akToken("border.radius.100", "3px"),
        backgroundColor: akToken("color.background.neutral.bold", "#091E42"),
        marginLeft: akToken("space.050", "4px")
    }
);

export type OrgIconSize = "large" | "medium";

export interface OrgIconProps {
    size?: OrgIconSize;
    primaryColor?: IconColor;
}

export const OrgIcon = (props: OrgIconProps) => (
    <OrgAvatarBackground>
        <AkOfficeBuildingIcon label="" color={props.primaryColor} />
    </OrgAvatarBackground>
);
